import { useState } from 'react';
import { LinkIcon } from '@heroicons/react/24/outline';
import { DmLinkModal } from './DmLinkModal';
import type { DmPrefillSource } from './dmPrefill.ts';

interface FindOrCreateDmActionProps {
    practiceId: string;
    label: string;
    prefillSource: DmPrefillSource;
    onLinked: () => void;
}

export function FindOrCreateDmAction({
    practiceId,
    label,
    prefillSource,
    onLinked
}: FindOrCreateDmActionProps) {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            <button
                type="button"
                onClick={() => setIsOpen(true)}
                className="self-start inline-flex items-center gap-1.5 h-8 px-3 rounded-md border border-gray-300 bg-white text-[13px] font-semibold text-gray-700 hover:bg-gray-50 hover:border-gray-400 transition-colors"
            >
                <LinkIcon className="h-3.5 w-3.5" />
                {label}
            </button>
            {isOpen && (
                <DmLinkModal
                    practiceId={practiceId}
                    prefillSource={prefillSource}
                    onLinked={onLinked}
                    onClose={() => setIsOpen(false)}
                />
            )}
        </>
    );
}
